import { render, staticRenderFns } from "./ViewMediaPage.vue?vue&type=template&id=17af5473&scoped=true&"
import script from "./ViewMediaPage.vue?vue&type=script&lang=js&"
export * from "./ViewMediaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17af5473",
  null
  
)

export default component.exports